import googleAnalytics from '@analytics/google-analytics';
import googleTagManager from '@analytics/google-tag-manager';
import Analytics from 'analytics';
import planhatPlugin from 'analytics-plugin-planhat';

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
const tagManagerId = import.meta.env.VITE_TAG_MANAGER_ID;
const planhatTenantToken = import.meta.env.VITE_PLANHAT_TENNANT_TOKEN;

const APP_MODE = import.meta.env.VITE_APP_MODE;

const extraPlugins =
  APP_MODE === 'production'
    ? [
        planhatPlugin({
          tenantUUID: planhatTenantToken
        })
      ]
    : [];

const analyticsInstance = Analytics({
  app: 'Aurora',
  debug: true,
  plugins: [
    googleAnalytics({
      measurementIds: [measurementId]
    }),
    googleTagManager({
      containerId: tagManagerId
    }),
    ...extraPlugins
  ]
});

export default analyticsInstance;
